import { Component, inject, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MatDialogRef,
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';
import { LoginContext } from '@app/@shared/model/logincontext.model';
import { AirCallService } from '@app/@shared/services/api/air-call.service';
import { PersonService } from '@app/@shared/services/api/person.service';
import { PropertiesService } from '@app/@shared/services/api/properties.service';
import { CredentialsService } from '@app/@shared/services/web/credentials.service';
import { AuthenticationService } from '@app/auth/authentication.service';
import { environment } from '@env/environment';
import { CookieService } from 'ngx-cookie-service';
import { ModalSuccesfullCustomComponent } from '../modal-succesfull-custom/modal-succesfull-custom.component';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { SpinnerComponent } from '../spinner/spinner.component';
import { SharedModule } from '@app/@shared/shared.module';
import { MatRadioModule } from '@angular/material/radio';
import { HubspotService } from '@app/@shared/services/api/hubspot.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RouterLink } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DatalayerService } from '@app/@shared/services/web/datalayer.service';

@Component({
  selector: 'app-we-call-you',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatSnackBarModule,
    TranslateModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatFormFieldModule,
    FormsModule,
    SpinnerComponent,
    SharedModule,
    MatRadioModule,
    MatCheckboxModule,
    RouterLink,
  ],
  templateUrl: './we-call-you.component.html',
  styleUrl: './we-call-you.component.scss',
})
export class WeCallYouComponent implements OnInit {
  airCallFormGroup: FormGroup;
  currentNumber: number;
  errorMessage: string;
  isLoading = false;
  private cookieHsUtk: string;

  private readonly DEFAULT_FORM_ID = '04020e86-4652-4104-8eb9-f97f1b9f0747';
  private readonly HUBSPOT_CONFIG = {
    region: 'na1',
    portalId: '7733651',
  };

  constructor(
    public dialogRef: MatDialogRef<WeCallYouComponent>,
    public authenticationService: AuthenticationService,
    private registerService: PersonService,
    private airCallService: AirCallService,
    private readonly dialog: MatDialog,
    private propertiesService: PropertiesService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public credentialsService: CredentialsService,
    private fb: FormBuilder,
    private hubspotService: HubspotService,
    public translateService: TranslateService,
    @Inject(PLATFORM_ID) private platform: Object,
    private _cookieService: CookieService,
    private datalayerService: DatalayerService, /*Nuevo DatalayerService inyectado*/
  ) {}
 

  ngOnInit(): void {
    this.cookieHsUtk = this._cookieService.get('hubspotutk');
    this.airCallFormGroup = this.fb.group({
      do_you_invest_in: ['', []],
      first_name: ['', [Validators.maxLength(30), Validators.required]],
      last_name: ['', [Validators.maxLength(30), Validators.required]],
      email: [
        null,
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(50),
          Validators.email,
        ],
      ],
      phone_number: ['', [Validators.required]],
      code_country: [null, []],
      terms: [false, [Validators.requiredTrue]],
      receive_info: [false, []],
    });

    if (this.credentialsService.isAuthenticated()) {
      const currentUser = this.credentialsService.credentials;
      this.airCallFormGroup.patchValue({
        first_name: currentUser.first_name,
        last_name: currentUser.last_name,
        email: currentUser.email,
        phone_number: this.getPhone().number,
        code_country: this.getPhone().code,
      });
    }
    if (environment.production) {
      this.airCallService.listNumbers().subscribe((data: any) => {
        this.currentNumber = data.numbers[0].id;
      });
    }
  }

  getPhone(): { number: string; code: string } {
    const splNumber = this.credentialsService?.credentials.phone.split('-');
    if (splNumber.length > 1) {
      return {
        number: splNumber[1],
        code: splNumber[0],
      };
    } else {
      return {
        number: splNumber[0],
        code: '34',
      };
    }
  }

  sendRegister(): void {
    this.isLoading = true;
    const email = this.airCallFormGroup.get('email').value;
    if (this.credentialsService.isAuthenticated()) {
      this.startCall(false);
    } else {
      this.propertiesService.getEmail(email).subscribe((resp) => {
        if (Object.keys(resp).length === 0) {
          const newPassword = this.randomPassword(10);
          const newPerson: any = {
            typeHS: 'AIRCALL',
            email: this.airCallFormGroup.get('email').value,
            receiveNotifications: true,
            receiveNotificationsContent:
              this.airCallFormGroup.get('receive_info').value,
            receiveNotificationsProcesses: true,
            receiveNotificationsCommercial:
              this.airCallFormGroup.get('receive_info').value,
            password: newPassword,
            repeat_password: newPassword,
            cookieHsUtk: this.cookieHsUtk,
            person: {
              first_name: this.airCallFormGroup.get('first_name').value,
              last_name: this.airCallFormGroup.get('last_name').value,
              phone: {
                number: this.airCallFormGroup.get('phone_number').value,
                code_country:
                  this.airCallFormGroup.get('code_country').value.phone_code,
              },
            },
            authorities: {
              authority: { id_authority: 3 },
            },
            user_contact: {
              contact_email: false,
              contact_phone: true,
              contact_sms: false,
            },
            page: {
              url: window.location.href,
              title: document.title,
            },
          };
          this.registerService.registerUnCover(newPerson).subscribe(() => {
            this.authenticationService
              .login({ email, password: newPassword } as LoginContext)
              .subscribe(() => {
                this.startCall(true);
              });
          });
        } else {
          this.startCall(false);
        }
      });
    }
  }

  randomPassword(length: number) {
    let result = '';
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result + 'i24';
  }

  openDialogAlert(message: string, needValidate: boolean): void {
    this.dialog.open(ModalSuccesfullCustomComponent, {
      data: {
        alertCom: true,
        message,
        needValidate,
      },
      position: { top: 'true' },
      panelClass: 'no-icon-modal',
    });
  }

  startCall(needValidate: boolean): void {
    if (environment.production) {
      const phoneNumber = this.airCallFormGroup.get('phone_number').value;
      const codeCountry =
        '+' + this.airCallFormGroup.get('code_country').value.phone_code;

      this.airCallService.getAvailableAgents().subscribe((data: any) => {
        const availableAgents = data.users.filter(
          (u: any) => u.availability === 'available'
        );
        if (availableAgents.length !== 0) {
          const selectedAgent =
            availableAgents[Math.floor(Math.random() * availableAgents.length)];
          const phone = codeCountry + phoneNumber;
          this.airCallService
            .startOutboundCall(selectedAgent.id, phone, this.currentNumber)
            .subscribe({
              next: () => {
                this.isLoading = false;
                this.dialogRef.close();
                this.openDialogAlert(
                  'components.airCall.success',
                  needValidate
                );
              },
              error: (error) => {
                this.isLoading = false;
                this.errorMessage =
                  'components.airCall.' + error.error.troubleshoot;
              },
            });
        } else {
          this.isLoading = false;
          this.dialogRef.close();
          this.openDialogAlert('components.airCall.noDisponible', needValidate);
        }
      });
    } else {
      this.isLoading = false;
      this.openDialogAlert('components.airCall.success', needValidate);
      this.dialogRef.close();
    }
  }

  sendHubspotData(): void {
    const formValue = this.airCallFormGroup.getRawValue();
    const phoneNumber = formValue.phone_number;
    const codeCountry = '+' + formValue.code_country.phone_code;

    const fields: { name: string; value: string }[] = [
      {
        name: 'que_quieres_hacer_en_inviertis_',
        value: formValue.do_you_invest_in ?? '',
      },
      {
        name: 'phone',
        value: codeCountry + phoneNumber,
      },
      {
        name: 'firstname',
        value: formValue.first_name ?? '',
      },
      { name: 'lastname', value: formValue.last_name ?? '' },
      {
        name: 'email',
        value: formValue.email ?? '',
      },
    ];

    if (this.data?.monthlyIncome && this.data?.investmentNeeded) {
      const fmt = (n: number) => new Intl.NumberFormat('en-US').format(n);
      fields.push({
        name: 'preferencias_de_inversion',
        value: `Ingreso mensual deseado: ${fmt(this.data.monthlyIncome)}€/mes | Inversión propuesta desde: ${fmt(this.data.investmentNeeded)}€`,
      });
    }

    const hubspotData = {
      fields,
      submittedAt: Date.now(),
      context: {
        hutk: this._cookieService.get('hubspotutk'),
        pageUri: isPlatformBrowser(this.platform) ? window.location.href : '',
        pageName: 'Formulario Te Llamamos',
      },
    };

    this.isLoading = true;
    this.hubspotService
      .postToHubspot(
        hubspotData,
        this.HUBSPOT_CONFIG.portalId,
        this.DEFAULT_FORM_ID
      )
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.dialogRef.close();
          this.openDialogAlert(
            'components.airCall.success',
            this.credentialsService.isAuthenticated() ? false : true
          );
          // Evento google tag manager para el datalayer por envio exitoso del formulario
          this.datalayerService.push('form_submitted', { 
              form_id: this.DEFAULT_FORM_ID,
              form_name: 'Formulario Te Llamamos',
              form_location: 'modal',
              page_language: this.translateService.getCurrentLang(),
              page_location: isPlatformBrowser(this.platform) ? window.location.href : '',
              page_path: isPlatformBrowser(this.platform) ? window.location.pathname : ''
          });
        },
        error: () => {
          this.isLoading = false;
          this.errorMessage = 'components.airCall.errorOccurred';
        },
      });
  }
}
